<template>
    <div>
        <!-- <slot name="title">
            <h2>智能地址填写</h2>
        </slot> -->
        <div class="smart_address_box">
            <a-textarea v-model="address" :rows="1" :maxLength="255"
                style="border:none; padding: 0;resize: none;min-height:100px;"
                placeholder="请将地址黏贴至识别框内，如【某某某 12321……33 江苏省 南通市 崇川区 任港街道 256栋603 226001】" />
            <div class="footer">
                <p class="text_red">如地址不能识别，请将地址改成 省 市 区 ，格式不要重复。</p>
                <a-button class="shibie" :disabled="!address" @click="recognize" :loading="loading"
                    type="primary">识别</a-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SmartAddressTextarea',
    data() {
        return {
            address: '',
            loading: false
        }
    },
    methods: {
        recognize() {
            var _this = this;
            const _address = _this.address
            if (!_address) return;
            _this.loading = true
            _this.$util.api('/address/discern', {
                str: _address
            }, function (res) {
                _this.loading = false

                if (res.code == 10000) {
                    // _this.address = '';
                    let regionIDs = [res.data.province.id || 0, res.data.city.id || 0, res.data.district.id || 0, res.data.town.id || 0]

                    console.log(regionIDs);
                    _this.$EventBus.$emit('regionIDs', regionIDs)

                    _this.$nextTick(() => {
                        _this.$emit('ok', res.data)
                        _this.$confirm({
                            title: '请确认地址识别是否正确?',
                            content: '地址模糊识别并不能保证每次都正确认别，请仔细核对！',
                            okText: '我知道了'
                        });
                    })
                } else {
                    _this.$message.error(res.msg);
                }
            });
        }
    }
}
</script>

<style scoped>
.text_red {
    color: #ff1a36;
    transform: translateY(30px);
}

.footer {
    display: flex;
    justify-content: space-between;
    margin-left: 5px;
}

.footer ::v-deep .ant-btn {
    min-width: 48px;
}

.smart_address_box {
    border: 1px solid #D8D8D8;
    border-radius: 4px;
    padding: 10px;
}

.smart_address_box .shibie {
    width: 48px;
    height: 26px;
    border-radius: 4px;
    margin-top: 25px;
    font-size: 13px;
    font-family: AlibabaPuHuiTiR;
    color: #FD5902 !important;
    line-height: 14px;
    background: #FFF3ED !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/address/SmartAddressTextarea.vue